import {
  Colors,
  IcMediaLibrary,
  IcPlaylist,
  IcScreen,
  IcStorage,
  Text,
} from 'basic-ui-lib';
import { ISummaryStore } from 'modules/media/interfaces/api';
import styled from 'styled-components';

interface StoreStatisProps {
  data: ISummaryStore;
}

const StoreStatis = ({ data }: StoreStatisProps) => {

  return (
    <StatsGrid>
      <StatCard>
        <StatIconWrapper type='screens'>
          <IcScreen fill={Colors.primary[6]} width={32} height={32} />
        </StatIconWrapper>

        <StatContent>
          <Text title_h6 semibold>
            {data?.totalOnline + data?.totalOffline}
          </Text>
          <Text content_2 medium color='neutral.text.3'>
            Screens
          </Text>
        </StatContent>

        <StatDetails>
          <StatDetail>
            <OnlineDot />
            <Text content_2 medium color='neutral.text.3'>
              {data?.totalOnline} Online
            </Text>
          </StatDetail>

          <StatDetail>
            <OfflineDot />
            <Text content_2 medium color='neutral.text.3'>
              {data?.totalOffline} Offline
            </Text>
          </StatDetail>
        </StatDetails>
      </StatCard>

      <StatCard>
        <StatIconWrapper type='media'>
          <IcMediaLibrary fill={Colors.secondary[5]} width={32} height={32} />
        </StatIconWrapper>

        <StatContent>
          <Text title_h8 semibold>
            {data?.totalImages + data?.totalVideos}
          </Text>
          <Text content_2 medium color='neutral.text.3'>
            Media
          </Text>
        </StatContent>

        <StatDetails>
          <StatDetail>
            <OnlineDot />
            <Text content_2 medium color='neutral.text.3'>
              {data?.totalImages} Images
            </Text>
          </StatDetail>

          <StatDetail>
            <OfflineDot />
            <Text content_2 medium color='neutral.text.3'>
              {data?.totalVideos} Videos
            </Text>
          </StatDetail>
        </StatDetails>
      </StatCard>

      <StatCard>
        <StatIconWrapper type='playlist'>
          <IcPlaylist fill={Colors.other[3]} width={32} height={32} />
        </StatIconWrapper>

        <StatContent>
          <Text title_h8 semibold>
            {data?.playlistActive}
          </Text>
          <Text content_2 medium color='neutral.text.3'>
            Playlists
          </Text>
        </StatContent>

        <StatDetails>
          <StatDetail>
            <OnlineDot />
            <Text content_2 medium color='neutral.text.3'>
              {data?.playlistActive} Active
            </Text>
          </StatDetail>

          {/* <StatDetail>
            <DraftDot />
            <Text content_2 medium color='neutral.text.3'>
              5 Draft
            </Text>
          </StatDetail> */}
        </StatDetails>
      </StatCard>

      <StatCard>
        <StatIconWrapper type='storage'>
          <IcStorage width={32} height={32} />
        </StatIconWrapper>

        <StatContent>
          <Text title_h8 semibold>
            {data?.storageUsed} GB
          </Text>
          <Text content_2 medium color='neutral.text.3'>
            Storage Used
          </Text>
        </StatContent>
      </StatCard>
    </StatsGrid>
  );
};
export default StoreStatis;

const StatsGrid = styled.div`
  display: grid;

  grid-template-columns: repeat(4, 1fr);

  gap: 14px;

  margin-top: 12px;
`;

const StatCard = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(31, 45, 61, 0.05);
  gap: 16px;
`;

const StatIconWrapper = styled.div<{
  type: 'screens' | 'media' | 'playlist' | 'storage';
}>`
  width: 60px;
  height: 60px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  background: ${({ type }) => {
    switch (type) {
      case 'screens':
        return Colors.primary[1];

      case 'media':
        return Colors.secondary[1];

      case 'playlist':
        return Colors.other[1];

      case 'storage':
        return Colors.purple[1];

      default:
        return '#f5f6f8';
    }
  }};
`;

const StatContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const StatDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: auto;
`;

const StatDetail = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
`;

const OnlineDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${Colors.secondary[5]};
`;

const OfflineDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${Colors.other[3]};
`;
